import type { Middleware } from 'openapi-fetch';
import createClient from 'openapi-fetch';
import type { paths } from '#/types/api/zenid-mypage-api';
import type { PutAccountRequestData } from '#/types/api/accounts';
import { auth0Client } from '#/utils/auth/auth0Client';

const authMiddleware: Middleware = {
  async onRequest(request) {
    const accessToken = await auth0Client.getTokenSilently();
    request.headers.set('Authorization', `Bearer ${accessToken}`);
    return request;
  },
};

const client = createClient<paths>({ baseUrl: import.meta.env.VITE_API_URL });
client.use(authMiddleware);

/**
 * ログインしているユーザーのユーザー情報を取得する
 *
 * TODO: mypage-apiのドキュメントに差し替える
 * @see https://special-adventure-vyo64mo.pages.github.io/#tag/accounts/operation/AccountApi_read
 */
export async function getAccount() {
  return await client.GET('/accounts');
}

/**
 * ログインしているユーザーの登録メールアドレスを変更する
 */
export async function putAccount(requestData: PutAccountRequestData) {
  return await client.PUT('/accounts', {
    body: requestData,
  });
}

/**
 * ログインしているユーザーの登録メールアドレスへ検証メールを再度送信する
 */
export async function postVerifyEmail() {
  return await client.POST('/verify-email');
}

/**
 * MFA登録URLを発行する
 */
export async function postAuthenticationMethodEnrollments() {
  return await client.POST('/authentication-method-enrollments');
}

/**
 * 登録済みのMFAの一覧を取得する
 */
export async function getAuthenticationMethods() {
  return await client.GET('/authentication-methods');
}

/**
 * 登録済みのMFAを削除する
 */
export async function deleteAuthenticationMethods(authenticationMethodId: string) {
  return await client.DELETE('/authentication-methods/{authenticationMethodId}', {
    params: {
      path: {
        authenticationMethodId,
      },
    },
  });
}
